import { Card, CardContent, Progress } from "@pushpress/pushpress-ui";
import { useOnboardingTaskListsQuery } from "../../../apis/taskApi.hooks";
import { useNavigate } from "../../../hooks/useNavigate";

const GetStartedProgressBar = () => {
  const navigate = useNavigate();
  const { data: taskList, isLoading } = useOnboardingTaskListsQuery();
  const tasks = taskList?.[0]?.tasks;

  if (isLoading) {
    return (
      <Card className="tw-mb-6">
        <CardContent className="tw-p-6 tw-pt-6">
          <div className="tw-flex tw-flex-col sm:tw-flex-row tw-items-center tw-gap-4">
            <p className="tw-text-sm tw-text-gray-500">
              You are currently setting up! Go to{" "}
              <span
                onClick={() => navigate("/start")}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    navigate("/start");
                  }
                }}
                role="button"
                tabIndex={0}
                className="tw-text-blue-500 hover:tw-underline tw-cursor-pointer"
              >
                Get Started
              </span>{" "}
              to finish setup.
            </p>
            <div className="tw-flex tw-items-center tw-gap-4 tw-w-full sm:tw-flex-1">
              <Progress
                value={0}
                rootColor="tw-bg-blue-200"
                indicatorColor="tw-bg-blue-500"
                className="tw-flex-grow"
              />
              <span className="tw-text-sm tw-font-medium tw-whitespace-nowrap">
                {Math.round(0)}%
              </span>
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }

  if (isLoading || !taskList || !tasks || tasks.length === 0) {
    return null;
  }

  const progress =
    (tasks.reduce((acc, task) => acc + task.isComplete, 0) / tasks.length) *
    100;

  if (progress === 100) {
    return null;
  }

  return (
    <div className="">
      <Card className="tw-mb-6">
        <CardContent className="tw-p-6 tw-pt-6">
          <div className="tw-flex tw-flex-col sm:tw-flex-row tw-items-center tw-gap-4">
            <p className="tw-text-sm tw-text-gray-500">
              You are currently setting up! Go to{" "}
              <span
                onClick={() => navigate("/start")}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    navigate("/start");
                  }
                }}
                role="button"
                tabIndex={0}
                className="tw-text-blue-500 hover:tw-underline tw-cursor-pointer"
              >
                Get Started
              </span>{" "}
              to finish setup.
            </p>
            <div className="tw-flex tw-items-center tw-gap-4 tw-w-full sm:tw-flex-1">
              <Progress
                value={progress}
                rootColor="tw-bg-blue-200"
                indicatorColor="tw-bg-blue-500"
                className="tw-flex-grow"
              />
              <span className="tw-text-sm tw-font-medium tw-whitespace-nowrap">
                {Math.round(progress)}%
              </span>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default GetStartedProgressBar;
